<template>
  <BCard class="min-h-[100vh]">
    <div class="flex w-full justify-between items-center mb-4">
      <div class="flex gap-[12px] items-center">
        <BButton
          variant="primary"
          size="sm"
          class="!rounded-lg !p-[3px]"
          @click="$router.push('/partner-komchat')"
        >
          <img
            class="w-[20px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
            alt="arrow left"
          >
        </BButton>
        <div class="text-black font-semibold text-[24px]">
          Detail Partner
        </div>
      </div>

      <div class="flex items-center gap-3">
        <div class="border rounded-lg px-1 py-1.5 flex items-center gap-2">
          <img
            v-if="false"
            src="https://storage.googleapis.com/komerce/assets/icons/coin-komchat.svg"
            class="w-[20px]"
            alt="coin"
          >
          <!-- Mocking coin icon as emoji or standard icon since I don't have exact URL -->
          <span class="text-yellow-500 font-bold">🪙</span>
          <span class="text-black font-semibold">{{ IDRWithoutLbl(detailData.komchat_coin) }}</span>
        </div>
        <div class="border rounded-lg px-1 py-1.5 flex items-center gap-2">
          <span class="text-[#828282]">Sisa Masa Berlangganan:</span>
          <span class="text-black font-semibold">{{ subscriptionDays }} hari</span>
        </div>
        <div
          class="rounded-lg px-2.5 py-1.5 text-center font-medium select-none"
          :class="[
            (partnerInfo.isActive || '').toLowerCase() === 'active' ? 'bg-[#DCFCE7] text-[#22C55E]' : 'bg-[#FEE2E2] text-[#EF4444]',
            (partnerInfo.isActive || '').toLowerCase() !== 'expired' ? 'cursor-pointer transition-opacity hover:opacity-80' : 'cursor-default'
          ]"
          @click="openStatusModal"
        >
          {{ partnerInfo.isActive }}
        </div>
      </div>
    </div>

    <!-- Informasi Partner -->
    <BCard
      no-body
      class="border mb-4"
    >
      <div class="px-1 py-1 border-b border-[#E0E0E0]">
        <div class="text-black font-semibold text-base">
          Informasi Partner
        </div>
      </div>
      <BCardBody>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Nama Partner
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.name || '-' }}
            </div>
          </div>
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Email
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.email || '-' }}
            </div>
          </div>
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Nomor
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.phone || '-' }}
            </div>
          </div>
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Jenis Berlangganan
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.subscription || '-' }}
            </div>
          </div>
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Tanggal Bergabung
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.joinDate || '-' }}
            </div>
          </div>
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Tanggal Expired
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.expireDate || '-' }}
            </div>
          </div>
          <div>
            <div class="text-[#828282] text-[12px] mb-1">
              Tipe User
            </div>
            <div class="text-black font-medium text-[14px]">
              {{ partnerInfo.userType }}
            </div>
          </div>
        </div>
      </BCardBody>
    </BCard>

    <BOverlay
      :show="isLoading"
      rounded="sm"
    >
      <!-- Informasi Komchat AI -->
      <BCard
        no-body
        class="border mb-4"
      >
        <div class="px-1 py-1 border-b border-[#E0E0E0]">
          <div class="text-black font-semibold text-base">
            Informasi Komchat AI
          </div>
        </div>
        <BCardBody>
          <div v-if="detailData.komchat_ai && detailData.komchat_ai.agents && detailData.komchat_ai.agents.length > 0">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div
                v-for="(agent, idx) in detailData.komchat_ai.agents"
                :key="agent.id"
                class="pr-4"
              >
                <div class="text-[#828282] text-[12px] mb-1">
                  Agent {{ idx + 1 }}
                </div>
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-2">
                    <span class="text-black font-medium text-[14px]">{{ agent.phone }}</span>
                    <span
                      v-if="agent.is_active"
                      class="bg-[#DCFCE7] text-[#22C55E] text-[10px] px-[4px] py-0.5 rounded"
                    >Aktif</span>
                    <span
                      v-else
                      class="bg-[#FEE2E2] text-[#EF4444] text-[10px] px-[4px] py-0.5 rounded"
                    >Tidak Aktif</span>
                  </div>
                  <div
                    class="cursor-pointer text-primary"
                    @click="openDeleteModal(agent.phone, 'komchat_ai')"
                  >
                    <b-icon icon="trash" />
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Jumlah Token
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ IDRWithoutLbl(detailData.komchat_ai.total_token) || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Leads
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_ai.leads | number || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Closing Order
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_ai.closing_order | number || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Top Up Komchat Coins
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_ai.topup_komchat_coin | number || '-' }}
                </div>
              </div>
              <div class="col-span-2">
                <div class="text-[#828282] text-[12px] mb-1">
                  Metode Pembayaran
                </div>
                <div class="text-black font-medium text-[14px] capitalize">
                  {{ (detailData.komchat_ai.payment_method || []).map(method => method === 'BANK_TRANSFER' ? 'Transfer Bank' : method).join(', ') || '-' }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="text-center py-4 text-[#828282]"
          >
            Tidak Ada Data
          </div>
        </BCardBody>
      </BCard>

      <!-- Informasi Komchat Lite -->
      <BCard
        no-body
        class="border mb-4"
      >
        <div class="px-1 py-1 border-b border-[#E0E0E0]">
          <div class="text-black font-semibold text-base">
            Informasi Komchat Lite
          </div>
        </div>
        <BCardBody>
          <div v-if="detailData.komchat_lite && detailData.komchat_lite.phones && detailData.komchat_lite.phones.length > 0">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div
                v-for="(phone, idx) in detailData.komchat_lite.phones"
                :key="phone.id"
                class="pr-4"
              >
                <div class="text-[#828282] text-[12px] mb-1">
                  Nomor Broadcast {{ idx + 1 }}
                </div>
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-2">
                    <span class="text-black font-medium text-[14px]">{{ phone.phone }}</span>
                    <span
                      v-if="phone.is_active"
                      class="bg-[#DCFCE7] text-[#22C55E] text-[10px] px-2 py-0.5 rounded"
                    >Aktif</span>
                    <span
                      v-else
                      class="bg-[#FEE2E2] text-[#EF4444] text-[10px] px-2 py-0.5 rounded"
                    >Tidak Aktif</span>
                  </div>
                  <b-icon
                    class="cursor-pointer text-primary"
                    icon="trash"
                    @click="openDeleteModal(phone.phone, 'komchat_lite')"
                  />
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Jumlah Template
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_lite.total_template | number || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Riwayat Broadcast
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_lite.total_broadcast | number || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Jumlah Penerima
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_lite.total_user | number || '-' }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="text-center py-4 text-[#828282]"
          >
            Tidak Ada Data
          </div>
        </BCardBody>
      </BCard>

      <!-- Informasi Komchat For Brands -->
      <BCard
        no-body
        class="border mb-4"
      >
        <div class="px-1 py-1 border-b border-[#E0E0E0]">
          <div class="text-black font-semibold text-base">
            Informasi Komchat For Brands
          </div>
        </div>
        <BCardBody>
          <div v-if="detailData.komchat_for_brand.account_name !== '' || detailData.komchat_for_brand.phone">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="pr-4">
                <div class="text-[#828282] text-[12px] mb-1">
                  Akun Facebook
                </div>
                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-2">
                    <span class="text-black font-medium text-[14px]">{{ detailData.komchat_for_brand.account_name || '-' }}</span>
                    <span
                      v-if="detailData.komchat_for_brand.is_active"
                      class="bg-[#DCFCE7] text-[#22C55E] text-[10px] px-2 py-0.5 rounded"
                    >Aktif</span>
                    <span
                      v-else
                      class="bg-[#FEE2E2] text-[#EF4444] text-[10px] px-2 py-0.5 rounded"
                    >Tidak Aktif</span>
                  </div>
                  <b-icon
                    class="cursor-pointer text-primary"
                    icon="trash"
                    @click="openDeleteModal(detailData.komchat_for_brand.phone, 'komchat_for_brand')"
                  />
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Nomor
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_for_brand.phone || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Templates
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_for_brand.template | number || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  History Broadcast
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_for_brand.total_broadcast | number || '-' }}
                </div>
              </div>
              <div>
                <div class="text-[#828282] text-[12px] mb-1">
                  Data Penerima
                </div>
                <div class="text-black font-medium text-[14px]">
                  {{ detailData.komchat_for_brand.total_user | number || '-' }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="text-center py-4 text-[#828282]"
          >
            Tidak Ada Data
          </div>
        </BCardBody>
      </BCard>
    </BOverlay>

    <ModalDelete
      v-model="showDeleteModal"
      :target-number="deleteTargetNumber"
      @confirm="handleDeleteConfirm"
    />

    <ModalConfirmation
      v-model="showStatusModal"
      title="Apa Kamu Yakin?"
      :message="statusModalMessage"
      confirm-text="Lanjut"
      cancel-text="Batal"
      :loading="isSubmittingStatus"
      @confirm="handleStatusConfirm"
    />
  </BCard>
</template>

<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { DDMMYYYY } from '@/libs/filterDate'
import { apiDetailPartnerKomchat, apiDeleteNumberKomchat, apiExpirePartnerKomchat } from '../services/api.komchat.service'
import ModalDelete from '../components/ModalDelete.vue'
import ModalConfirmation from '../components/ModalConfirmation.vue'

export default {
  name: 'DetailPartnerKomchat',
  components: {
    ModalDelete,
    ModalConfirmation,
  },
  data() {
    return {
      isLoading: false,
      isSubmittingStatus: false,
      detailData: {
        komchat_ai: null,
        komchat_lite: null,
        komchat_for_brand: null,
      },
      partnerInfo: {
        userId: null,
        partnerId: null,
        name: '',
        email: '',
        phone: '',
        subscription: '',
        joinDate: '',
        expireDate: '',
        userType: '',
        isActive: '',
      },
      coin: 0,
      subscriptionDays: 0,

      showDeleteModal: false,
      deleteTargetNumber: '',
      deleteTargetServiceType: '',

      showStatusModal: false,
    }
  },
  computed: {
    statusModalMessage() {
      const current = (this.partnerInfo.isActive || '').toLowerCase()
      const isAktif = current === 'active' || current === 'aktif'
      let statusText = 'aktif'
      if (!isAktif && this.partnerInfo.isActive) {
        statusText = current
      }
      return `Status <span class="font-semibold text-black">${statusText}</span> akan diubah menjadi <span class="font-semibold text-black">expired</span> secara permanen. Lanjutkan?`
    },
  },
  mounted() {
    this.fetchDetailData()
  },
  methods: {
    IDRWithoutLbl,
    DDMMYYYY,
    async fetchDetailData() {
      this.isLoading = true
      try {
        const { id } = this.$route.params
        let { partnerData } = this.$route.params

        const storageKey = `partner_detail_${id}`
        if (!partnerData) {
          const cached = sessionStorage.getItem(storageKey)
          if (cached) {
            try {
              partnerData = JSON.parse(cached)
            } catch (e) {
              partnerData = null
            }
          }
        } else {
          sessionStorage.setItem(storageKey, JSON.stringify(partnerData))
        }

        if (!partnerData) {
          this.$toast_warning({ message: 'Data partner tidak ditemukan' })
          this.$router.replace('/partner-komchat')
          return
        }

        const isExpired = (partnerData.status || '').toLowerCase() === 'expired'

        this.partnerInfo = {
          userId: partnerData.user_id || id,
          partnerId: partnerData.partner_id || null,
          name: partnerData.partner_name || '-',
          email: partnerData.partner_email || '-',
          phone: partnerData.partner_phone ? `0${partnerData.partner_phone}` : '-',
          subscription: partnerData.subscription || '-',
          joinDate: partnerData.join_date ? this.DDMMYYYY(partnerData.join_date) : '-',
          expireDate: partnerData.subscription_date ? this.DDMMYYYY(partnerData.subscription_date) : '-',
          userType: partnerData.is_new ? 'New' : 'Existing',
          isActive: partnerData.status || '-',
        }

        if (partnerData.subscription_date && !isExpired) {
          const expDate = new Date(partnerData.subscription_date)
          const today = new Date()
          const diffTime = expDate - today
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
          this.subscriptionDays = diffDays > 0 ? diffDays : 0
        } else {
          this.subscriptionDays = 0
        }

        const { data } = await apiDetailPartnerKomchat(id)

        if (data.data) {
          // Ekstrak payment_method dari array agents jika tidak ada di root
          if (data.data.komchat_ai && data.data.komchat_ai.agents && !data.data.komchat_ai.payment_method) {
            const methods = data.data.komchat_ai.agents.flatMap(a => a.payment_method || [])
            data.data.komchat_ai.payment_method = [...new Set(methods)]
          }

          this.detailData = {
            komchat_ai: data.data.komchat_ai || null,
            komchat_lite: data.data.komchat_lite || null,
            komchat_for_brand: data.data.komchat_for_brand || null,
            komchat_coin: data.data.komchat_coin || 0,
          }
        }
      } catch (err) {
        this.$toast_error({ message: 'Gagal mengambil data detail partner' })
      } finally {
        this.isLoading = false
      }
    },
    openDeleteModal(number, serviceType) {
      this.deleteTargetNumber = number
      this.deleteTargetServiceType = serviceType
      this.showDeleteModal = true
    },
    async handleDeleteConfirm() {
      try {
        const { id } = this.$route.params
        const userId = this.partnerInfo.userId || this.$route.params.partnerData?.user_id || id
        const payload = {
          phone_number: this.deleteTargetNumber,
          service_type: this.deleteTargetServiceType,
        }
        await apiDeleteNumberKomchat(userId, payload)
        this.showDeleteModal = false
        this.$toast_success({ message: `Data untuk nomor ${this.deleteTargetNumber} berhasil dihapus` })
        this.fetchDetailData()
      } catch (err) {
        this.$toast_error({ message: `Gagal menghapus nomor ${this.deleteTargetNumber}` })
      }
    },
    openStatusModal() {
      const current = (this.partnerInfo.isActive || '').toLowerCase()
      if (current === 'expired') {
        return
      }
      this.showStatusModal = true
    },
    async handleStatusConfirm() {
      this.isSubmittingStatus = true
      try {
        const { id } = this.$route.params
        const partnerId = this.partnerInfo.partnerId || this.$route.params.partnerData?.partner_id || id
        await apiExpirePartnerKomchat(partnerId)

        this.partnerInfo.isActive = 'Expired'
        this.subscriptionDays = 0

        // Update route params jika ada
        if (this.$route.params.partnerData) {
          this.$route.params.partnerData.status = 'Expired'
        }

        // Update sessionStorage agar saat di-reload tetap 'Expired'
        const storageKey = `partner_detail_${id}`
        const cached = sessionStorage.getItem(storageKey)
        if (cached) {
          try {
            const parsed = JSON.parse(cached)
            parsed.status = 'Expired'
            sessionStorage.setItem(storageKey, JSON.stringify(parsed))
          } catch (e) {
            // ignore
          }
        }

        this.showStatusModal = false
        this.$toast_success({ message: 'Status partner berhasil diubah menjadi expired' })
        this.fetchDetailData()
      } catch (err) {
        this.$toast_error({ message: err?.response?.data?.meta?.message || 'Gagal mengubah status partner' })
      } finally {
        this.isSubmittingStatus = false
      }
    },
  },
}
</script>
